export default {
    menuhome: {
        dataTestid: 'connect-home-link',
        linkTo: 'http://www.library.uq.edu.au',
        primaryText: 'Library home',
    },
    responsiveClose: {
        dataTestid: 'close-action',
        primaryText: 'Close',
    },
    contactus: {
        // used in various spots - this should match the megamenu entry
        link: 'https://web.library.uq.edu.au/contact-us',
    },
};
